export function AccountInfo(value: string) {
    //
    let moovPrefice=['55','58','64','65','68','95','98','99']
    let moov=moovPrefice.includes(value.substring(3,5))
    return {type:moov?"MOOV":"MTN",number:value}
  }